<div class="container pt-3">
  <div class="row justify-content-sm-center">
      
    <div class="col-sm-6 col-md-4">
        <br>
        <div class="logo-text" >friggkantine<span class="copyrights">®</span></div>
        <!-- <img src="assets/img/henther.svg" width="355"> -->
        <br><br>
        <div class="alert alert-danger" *ngIf= "error">
          <strong>Error:</strong> {{error['message']}}
        </div>

        <!-- Account Linking Success Message -->
        <div class="alert alert-success" *ngIf="linkingSuccess">
          <strong>Success!</strong> Account linked successfully!
        </div>

        <!-- Account Linking Error Message -->
        <div class="alert alert-danger" *ngIf="linkingError">
          <strong>Linking Error:</strong> {{linkingError['message']}}
        </div>

        <!-- Account Linking Options -->
        <div class="alert alert-info" *ngIf="showLinkingOptions">
          <h6><strong>Link Additional Sign-in Methods</strong></h6>
          <p class="small mb-3">You can now link your Google or Microsoft account to your existing account for easier sign-in next time.</p>
          
          <div class="row no-gutters">
            <div class="col-6 pr-1">
              <button 
                class="btn btn-outline-primary btn-sm btn-block"
                type="button"
                (click)="linkGoogleAccount()">
                <img src="assets/img/google-logo.png" alt="Google logo" style="height:16px;">
                <span style="margin-left:8px; font-size:12px;">Link Google</span>
              </button>
            </div>
            <div class="col-6 pl-1">
              <button 
                class="btn btn-outline-primary btn-sm btn-block"
                type="button"
                (click)="linkMicrosoftAccount()">
                <img src="assets/img/microsoft-logo.png" alt="Microsoft logo" style="height:16px;">
                <span style="margin-left:8px; font-size:12px;">Link Microsoft</span>
              </button>
            </div>
          </div>
          
          <button 
            class="btn btn-link btn-sm mt-2 p-0" 
            type="button"
            (click)="dismissLinkingOptions()">
            Skip for now
          </button>
        </div>

        <!-- Loading Spinner -->
        <div class="text-center my-4" *ngIf="isLoading">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <p class="mt-2 text-muted">Signing in...</p>
        </div>

      <div class="card border-info text-center" [style.opacity]="isLoading ? '0.6' : '1'">
       <div class="card-header header-color text-left h1" style="font-size:1.5rem; padding-right: 1.5rem;">
        Sign in
      </div>
        <div class="card-body">
          <!-- <img src="https://placeimg.com/128/128/tech/sepia"> -->
          
          <form 
            class="form-signin" 
            (ngSubmit)="onSignin(f)" 
            #f="ngForm">
            <input 
              type="email" 
              class="form-control mb-2" 
              placeholder="Email" 
              id="email" 
              name="email" 
              ngModel 
              #email="ngModel" 
              email 
              required 
              autofocus
            >
            <input 
              type="password" 
              class="form-control mb-2" 
              placeholder="Password"   
              id="password" 
              name="password"  
              ngModel 
              required
            ><br>
            <button 
              class="btn btn-lg button btn-block mb-1 " [class.green-button]="valid(f)"
              type="submit">
              Sign in
            </button>
            <a [routerLink]="['/forgot']"   class="float-right">
              Forgot password?
            </a>
          </form>
          
          <!-- Divider -->
          <div class="text-center mt-5">
            <div class="d-flex align-items-center">
              <hr class="flex-grow-1">
              <span class="px-3 text-muted">or sign in with</span>
              <hr class="flex-grow-1">
            </div>
          </div>
          
          <!-- Sign-in Buttons -->
          <div class="row no-gutters mt-2">
            <div class="col-12 mb-3">
              <button 
                class="btn btn-outline-dark btn-block py-2"
                type="button"
                [disabled]="isLoading"
                (click)="onGoogleSignin()">
                <span class="d-flex align-items-center justify-content-center">
                  <img src="assets/img/google-logo.png" alt="Google logo" style="height:24px;" *ngIf="!isLoading">
                  <span *ngIf="!isLoading"style="margin-left:15px;">Sign in with Google</span>
                  <span class="spinner-border spinner-border-sm" role="status" *ngIf="isLoading"></span>
                  <span *ngIf="isLoading"> Signing in...</span>
                </span>
              </button>
            </div>
            <div class="col-12 mb-3">
              <button 
                class="btn btn-outline-dark btn-block py-2"
                type="button"
                [disabled]="isLoading"
                (click)="onMicrosoftSignin()">
                <span class="d-flex align-items-center justify-content-center">
                  <img src="assets/img/microsoft-logo.png" alt="Microsoft logo" style="height:24px" *ngIf="!isLoading">
                  <span *ngIf="!isLoading" style="margin-left:9px;">Sign in with Microsoft</span>
                  <span class="spinner-border spinner-border-sm" role="status" *ngIf="isLoading"></span>
                  <span *ngIf="isLoading"> Signing in...</span>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
      
      <!-- <a href="#" class="float-right">Create an account </a> -->
    </div>
  </div>
</div>
